import blog2 from '../Images/blogs/blog2.png'
import blog1 from '../Images/blogs/blog1.jpg'


const blogs = [
    {
        id: 1,
        title: "Experience I got from my first collaborative project of building the clone of Udemy",
        date: "04",
        month: "September",
        image: blog2,
        link: "https://medium.com/@omkarvgawade/experience-i-got-from-my-first-collaborative-project-of-building-the-clone-of-udemy-b449d9b4da5c"
    },
    {
        id: 2,
        title: "A cloned version of Trivago….",
        date: "04",
        month: "September",
        image: blog1,
        link: "https://medium.com/@omkarvgawade/a-cloned-version-of-trivago-547352830e37"
    },


]

export default blogs